<button id="id_pair_own_do_addBulk" class="btn btn-sm btn-action btn-light ml-2" data-toggle="modal"
    data-target="#addBulkDeviceModal" (click)="beginBulkRegister()">
    <i class="fas fa-plus-circle"></i>
    Bulk register devices
</button>
<div id="addBulkDeviceModal" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class='modal-dialog config-dlg'>
        <div class='modal-content'>
            <div class='modal-header'>
                <span class="modal-title">Bulk register devices</span>
                <button #dlgClose type="button" class="close" [disabled]="_dlgPage == _enumDlgPage.submit"
                    data-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div *ngIf="_dlgPage === _enumDlgPage.action">
                        Please prepare a CSV file with the following template :
                        <div>
                            <button type="button" class="btn btn-link" (click)="downloadBulkTemplate()">
                                Download devices CSV template
                            </button>
                            <a #bulkTemplateLink class="d-none"></a>
                        </div>
                        <div class="border rounded mt-4 px-2 pt-2 bg-gray-2">
                            <strong class="warning">Note :</strong>
                            <ul>
                                <li>Group name is case-sensitive</li>
                                <li>
                                    <div>Provide the full group path, starting from “Home” and separated by slashes
                                        (“/”), to distinguish device groups with the same name.</div>
                                    <div>For example: Home/GA/123 vs. Home/GB/123</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="_dlgPage === _enumDlgPage.submit">
                        <div class="progress">
                            <div class="progress-bar progress-bar-success progress-bar-striped active"
                                role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                                style="width: 100%">
                                Updating the changes... Please wait...
                            </div>
                        </div>
                        <div class="mt-2">{{ _batchPairProgress }}</div>
                    </div>
                    <div *ngIf="_dlgPage === _enumDlgPage.result">
                        <div *ngIf="_errorMessage; else templateShowResult" class="text-danger">{{ _errorMessage }}
                        </div>
                        <ng-template #templateShowResult>
                            <div class="d-flex align-items-center justify-content-between">
                                <strong>Register summary</strong>
                                <div class="d-flex">
                                    <div *ngFor="let status of _filters.keys()" class="ml-3">
                                        <input type="checkbox" [id]="'bulk-filter-' + status" class="cmn-checkbox"
                                            [checked]="_filters.get(status)"
                                            (change)="changeDisplayFilter(status, $event.target.checked)">
                                        <label [for]="'bulk-filter-' + status">
                                            <svg>
                                                <use xlink:href="#checkmark" />
                                            </svg>
                                            <span class="ml-1">{{ status | capitalFirstWord }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="list-group mt-1">
                                <div class="list-group-item list-group-header black">
                                    <div class="row align-items-center">
                                        <div class="col title">
                                            Device name
                                        </div>
                                        <div class="col title">
                                            MAC
                                        </div>
                                        <div class="col title">
                                            Register status
                                        </div>
                                        <div class="col title">
                                            Note
                                        </div>
                                    </div>
                                </div>
                                <div class="list-group-content list-group-hoverless">
                                    <div *ngFor="let pairInfo of _displayBatchPairInfos" class="list-group-item">
                                        <div class="row align-items-center">
                                            <div class="col text-break">
                                                {{ pairInfo.deviceName }}
                                            </div>
                                            <div class="col text-break">
                                                {{ pairInfo.mac }}
                                            </div>
                                            <div class="col text-break text-success">
                                                <span *ngIf="pairInfo.isFault; else templateRegisterPass"
                                                    class="text-danger">
                                                    Failed
                                                </span>
                                                <ng-template #templateRegisterPass>
                                                    Success
                                                </ng-template>
                                            </div>
                                            <div class="col text-break">
                                                {{ pairInfo.note }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div class="mt-4 mb-2 text-center">
                    <ng-container *ngIf="_dlgPage !== _enumDlgPage.result; else templateButtonResult">
                        <button *ngIf="_dlgPage !== _enumDlgPage.result" type="button"
                            class="btn btn-sm btn-action btn-light ml-2" [disabled]="_dlgPage == _enumDlgPage.submit"
                            data-dismiss="modal">
                            <i class="fas fa-times-circle mr-1"></i>
                            Cancel
                        </button>
                        <button type="button" class="btn btn-sm btn-action btn-light ml-2"
                            [disabled]="_dlgPage == _enumDlgPage.submit" (click)="importBulkRegisterContent()">
                            <i class="fas fa-plus mr-1"></i>
                            Import devices CSV
                        </button>
                    </ng-container>
                    <ng-template #templateButtonResult>
                        <button type="button" class="btn btn-sm btn-action btn-light" data-dismiss="modal">
                            <i class="fas fa-times-circle mr-1"></i>
                            Close
                        </button>
                        <button *ngIf="!_errorMessage" type="button" class="btn btn-sm btn-action btn-light ml-2"
                            (click)="downloadBulkResult()">
                            <i class="fas fa-download mr-1"></i>
                            Download result
                        </button>
                        <a #bulkResultLink class="d-none"></a>
                    </ng-template>
                    <input #filePicker type="file" accept=".csv" (change)="onBulkRegisterfileChange($event)"
                        aria-label="Select device file" class="d-none">
                </div>
            </div>
        </div>
    </div>
</div>